import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-carousel-prev",
  "use": "icon-carousel-prev-usage",
  "viewBox": "0 0 14 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 14 24\" id=\"icon-carousel-prev\">\n  <path fill=\"none\" fill-rule=\"evenodd\" stroke=\"currentColor\" stroke-width=\"2\" d=\"M13 .7L1.7 12 13 23.3\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol